/* ==========================================================================
   Accordéon mobile des onglets produit (Essence des Huiles, 5 oct. 2026)
   Sur mobile (moins de 750 px), les sections « Onglets caractéristiques » et
   « Onglets produit » passent en accordéon : un titre par onglet, + / −,
   le 1er ouvert. Sur ordinateur, rien ne change (onglets).
   Chargé par sections/mise-en-page-produit.liquid (case « Mobile : onglets en accordéon »).
   v2 (5 oct. 2026) : + / − plus petits et plus fins, sans filets (référence Typology) ;
   pictogrammes d'usage (« Relaxation »…) calés sur le bord du texte au lieu de déborder à gauche.
   v3 (5 oct. 2026) : titres dans la couleur du texte du site (plus en vert forêt).
   ========================================================================== */
(function () {
  var css =
    '.acc-m__head{display:none}' +
    '@media screen and (max-width:749px){' +
    '[data-acc] [role=tablist]{display:none!important}' +
    '[data-acc] .acc-m__head{display:flex;align-items:center;justify-content:space-between;gap:1.6rem;width:100%;margin:0;padding:1.2rem 0;background:none;border:0;border-radius:0;color:rgb(var(--color-foreground));text-align:left;cursor:pointer;font-family:var(--font-heading-family);font-style:var(--font-heading-style);line-height:1.2;letter-spacing:normal}' +
    '[data-acc] .acc-m__head:focus-visible{outline:.2rem solid rgba(var(--color-foreground),.5);outline-offset:.2rem}' +
    '[data-acc] [role=tabpanel]{display:none!important}' +
    '[data-acc] [role=tabpanel].acc-m--open{display:block!important;padding:.4rem 0 2rem}' +
    '.acc-m__icon{position:relative;flex:0 0 1.1rem;width:1.1rem;height:1.1rem}' +
    '.acc-m__icon:before,.acc-m__icon:after{content:"";position:absolute;left:0;right:0;top:50%;height:1px;margin-top:-.5px;background:currentColor}' +
    '.acc-m__icon:after{transform:rotate(90deg);transition:transform .2s ease}' +
    '.acc-m__head[aria-expanded=true] .acc-m__icon:after{transform:rotate(0)}' +
    '.oc-usages{margin-left:0!important}' +
    '}';

  function addStyle() {
    if (document.getElementById('acc-m-style')) return;
    var s = document.createElement('style');
    s.id = 'acc-m-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function build(content) {
    if (content.hasAttribute('data-acc')) return;
    var tabs = Array.prototype.slice.call(content.querySelectorAll('[role=tab]'));
    if (!tabs.length) return;
    content.setAttribute('data-acc', '');
    tabs.forEach(function (tab, i) {
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (!panel) return;
      var head = document.createElement('button');
      head.type = 'button';
      head.className = 'acc-m__head';
      ['h0', 'h1', 'h2'].forEach(function (c) { if (tab.classList.contains(c)) head.classList.add(c); });
      head.style.fontWeight = getComputedStyle(tab).fontWeight;
      head.setAttribute('aria-controls', panel.id);
      var label = document.createElement('span');
      label.textContent = tab.textContent.trim();
      var icon = document.createElement('span');
      icon.className = 'acc-m__icon';
      icon.setAttribute('aria-hidden', 'true');
      head.appendChild(label);
      head.appendChild(icon);
      var open = i === 0;
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.classList.toggle('acc-m--open', open);
      head.addEventListener('click', function () {
        var o = head.getAttribute('aria-expanded') !== 'true';
        head.setAttribute('aria-expanded', o ? 'true' : 'false');
        panel.classList.toggle('acc-m--open', o);
      });
      panel.parentNode.insertBefore(head, panel);
    });
  }

  function init() {
    addStyle();
    Array.prototype.forEach.call(document.querySelectorAll('.oc__content, .ts__content'), build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
